<template>
    <div>
        <div
            ref="videoHolder"
            class="content-widget"
            :class="{ 'is-playing': isPlaying }"
        >
            <a
                href="#"
                class="btn-play__cover"
                v-on:click.prevent="playVideo()"
            >
                <span class="btn-play">
                    <img
                        class="btn-play__img"
                        src="@/assets/images/play_btn.svg"
                        alt="play button image"
                        width="82"
                        height="96"
                    >
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Video',
        props: [
            'link',
            'active'
        ],
        data () {
            return {
                isPlaying: false,
                widget: null
            };
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'language',
                'protocol'
            ]),
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            playVideo() {
                if (this.widget) {
                    this.isPlaying = true;
                    this.widget.resume();
                }
            },
            render() {
                if (typeof this.$props.link !== 'null') {
                    let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/animation' + window.location.search;
                    if (this.language && !urlLink.includes('&language'))
                        urlLink += '&language=' + this.language;
                    Http.getData(urlLink).then(payload => {
                        if (payload) {
                            if (payload.language)
                                this.$i18n.locale = payload.language;
                            this.widget = new Habiteo.VideoWidget(this.$refs.videoHolder, payload);
                            EventBus.$emit('trackWidget', payload.tracking);
                        }
                    }).catch(error => {
                        EventBus.$emit('setErrorState', true, error);
                    });
                }
            }
        },
        watch: {
            active(val) {
                if (!val)
                    if (this.widget)
                        this.widget.pause();
                else
                    if (this.isPlaying)
                        this.widget.resume();
            }
        }
	};
</script>

<style lang="scss">
	@import "@/assets/scss/_common.scss";
	@import "@/assets/scss/components/_btn-play.scss";
</style>



// WEBPACK FOOTER //
// src/views/VideoWidget.vue